import React, { useState } from "react";
import SingleSelectButtonGroupWithOther from "../components/BrandsPartnerComponents/single_select_button_group_with_other";
import MultiSelectCheckboxGroup from "../components/BrandsPartnerComponents/multiselect_checkbox";
import { BrandsType } from "./dtos/brands.dtos";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";
import MultiSelectWithAddItem from "../components/BrandsPartnerComponents/MultiselectComponentWithAddItem";
import { useBrandsOnboarding } from "../../contexts/BrandsOnboardingContext";


interface Props {

  previousStep: () => void;
  nextStep: () => void;
  data: BrandsType;
  setData: React.Dispatch<React.SetStateAction<BrandsType>>;

}

const BusinessEngagementModelPage: React.FC<Props> = ({ previousStep, nextStep, data, setData }) => {
  const engagementmodels = [
    "Consignment",
    "Prepayment",
    // "Other",

  ];

  const [checkedEngagementModel, setCheckedEngagementModel] = useState(true);


  const options = [
    { value: 0, label: "0-1 years" },
    { value: 1, label: "1-2 years" },
    { value: 2, label: "2-5 years" },
    { value: 3, label: "5+ years" },
  ];
  const fob_cif_preference = [
    { value: 0, label: "FOB" },
    { value: 1, label: "CIF" },
    // { value: 2, label: "Other" },
  ];
  const marketing_investment = [
    { value: 0, label: "USD 1,000 - 5,000" },
    // { value: 1, label: "CIF" },
    // { value: 2, label: "Other" },
  ];

  const [otherInputValueFob, setOtherInputValueFob] = useState("");
  const { customOptionsMap, setCustomOptionsMap } = useBrandsOnboarding();

  const [otherInputValueMarketingInvestment, setOtherInputValueMarketingInvestment] = useState("");
  const [validationError, setValidationError] = useState<{
    [key: string]: string;
  }>({});
  const handleNext = () => {
    // Initialize an empty array for error messages
    let errorMessage: { [key: string]: string } = {};
    const engagement_model = data.engagement_model || []
    const tenure = data.exclusivity_tenure || ''
    const fob = data.fob_preference || []
    const marketing = data.marketing_investments || ''
    if (engagement_model.length === 0) {
      errorMessage.engagement_model = "Please select at least one item in Engagement Model. ";
    }
    if (tenure === '') {
      errorMessage.tenure = "Please select at least one item in Exclusivity Tenure. ";
    }
    if (fob.length === 0) {
      errorMessage.fob = "Please select at least one item in FOB/CIF Preference. ";
    }
    if (marketing === '') {
      errorMessage.marketing = "Please select at least one item in Marketing Investment. ";
    }
    setValidationError(errorMessage);
    if (Object.keys(errorMessage).length > 0) {
      return;
    }
    nextStep();
  }
  return (
    <div className="w-full max-w-[686px]">
      <div className="common-title pb-[12px]">Your Business Engagement Model</div>
      <div className="common-sub-text pb-[60px]">We’d love to understand how you operate when it comes to partnerships and product distribution. Let’s get into the details!</div>

      {/*Form */}
      <div className="flex flex-col gap-y-[32px]">

        {/* Types of Engagement Model  */}
        <MultiSelectWithAddItem
          isFromBrands={true}
          label="Types of Engagement Model"
          error={validationError.engagement_model}
          customOptionsMap={customOptionsMap}
          setCustomOptionsMap={setCustomOptionsMap}
          activeMarket="brands" // fixed value, or adapt if needed
          contextKey="engagementModel"
          options={engagementmodels}
          showAddCustom={true}
          showCheckBox={false}
          checked={checkedEngagementModel}
          setChecked={setCheckedEngagementModel}
          selected={data.engagement_model || []}
          setSelected={(val) =>
            setData((prev) => ({
              ...prev,
              engagement_model: val,
            }))
          }
        />


        {/* Years of Operation*/}
        <SingleSelectButtonGroupWithOther
  error={validationError.tenure}
  label="Exclusivity Tenure"
  options={options}
  selectedValue={data.exclusivity_tenure}
  setSelectedValue={(val) =>
    setData((prev) => ({
      ...prev,
      exclusivity_tenure: val.toString(),
    }))
  }
  showRadioButton={true}
/>



        {/*FOB/CIF Preference */}
        <SingleSelectButtonGroupWithOther
          error={validationError.fob}
          label="FOB/CIF Preference"
          options={fob_cif_preference}
          allowCustomOption={true} // ✅ Correct prop to allow adding custom option
          contextKey="fobPreference" // ✅ Unique key to manage custom options
          customOptionsMap={customOptionsMap}
          setCustomOptionsMap={setCustomOptionsMap}
          selectedValue={data.fob_preference[0]} // ✅ Directly pass selected string value
          setSelectedValue={(val) =>
            setData((curret) => ({
              ...curret,
              fob_preference: [val.toString()],
            }))
          }
          showRadioButton={true}
        />


        {/* Marketing Investment */}
        <SingleSelectButtonGroupWithOther
          error={validationError.marketing}
          label="Marketing Investment"
          options={marketing_investment}
          allowCustomOption={true} // ✅ Correct prop to allow adding custom option
          contextKey="marketingInvestment" // ✅ Unique key for this field
          customOptionsMap={customOptionsMap}
          setCustomOptionsMap={setCustomOptionsMap}
          selectedValue={data.marketing_investments}
          setSelectedValue={(val) =>
            setData((current) => ({
              ...current,
              marketing_investments: val.toString(),
            }))
          }
          showRadioButton={true}
        />

      </div>
      <div className={` mt-[20vh] inline-flex flex justify-end  gap-x-[8px] w-full md:w-auto`}>
        {<NavigationButton onClick={previousStep} label="Previous" type="text" />}
        <NavigationButton onClick={handleNext} label={'Submit'} type="primary" />


      </div>


    </div>
  );
};

export default BusinessEngagementModelPage;
